@if (menus) {
  <nav>
    @if (menus.synthese) {
      <a [routerLink]="menus.synthese.url" [class]="synthese">
        <pr-icon name="description"></pr-icon>
        <span class="plm hidden-xs">{{ menus.synthese.label }}</span>
      </a>
    }
    @if (current) {
      <span class="current">
        <span>{{ current.label }}</span>
      </span>
    }
    @if (menus.items && menus.items.length) {
      <div class="dropdown-container" dropdown>
        <a class="dropdown-toggle" dropdownToggle>
          <span class="prm hidden-xs text-ellipsis">{{ menus.label }}</span>
          <pr-icon name="expand_more"></pr-icon>
        </a>
        <ul class="dropdown-menu">
          @for (item of menus.items; track item; let i = $index) {
            <li>
              <a [routerLink]="item.url">
                <span>{{ item.label }}</span>
                @if (item.icon) {
                  <pr-icon
                    [name]="item.icon"
                    [ngClass]="item.iconColor"
                    [tooltip]="item.iconTooltip"
                    containerClass="ea-tooltip ea-md"
                    placement="bottom"
                  ></pr-icon>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </nav>
}
